import {Component} from 'react';
import injectSheet from 'react-jss';

import {rem, userSelect} from '-/styles/utils';
import {mainButton} from '-/styles/mixins/button';

const styles = theme => ({
    buttons: {
        margin: `${rem(18)} 0 0`,
        padding: `0 ${rem(30)} ${rem(25)}`
    },
    row: {
        display: 'flex',
        '&:not(:first-of-type)': {
            marginTop: rem(15)
        },
        '& $cell': {
            flex: 1
        }
    },
    cell: {
        '&:not(:only-child)': {
            '&:first-child': {
                marginRight: rem(5)
            }
        },
        '& a, & label': {
            ...mainButton(theme.colors.strong),
            ...userSelect('none'),
            padding: `${rem(10)} 0`,
            border: '1px solid #d2d2d2',
            margin: 0,
            letterSpacing: rem(1.2),
            lineHeight: rem(22),
            whiteSpace: 'nowrap',
            boxShadow: '0 1px 8px rgba(0, 0, 0, 0.12)',
            '& i': {
                verticalAlign: 'middle'
            }
        },
        '&:last-child': {
            '& a, & label': {
                color: 'white',
                boxShadow: '0 5px 4px rgba(0, 0, 0, 0.19)'
            }
        }
    }
});

class StepButtons extends Component {
    render() {
        const {buttons = [], classes = {}} = this.props;
        const stepButtons = Array.isArray(buttons) ? buttons : [buttons];

        return (
            <section className={classes.buttons}>
                <div className={classes.row}>
                    {stepButtons.map((button, idx) => {
                        return (
                            <div key={idx} className={classes.cell}>
                                {button}
                            </div>
                        );
                    })}
                </div>
            </section>
        );
    }
}

export default injectSheet(styles)(StepButtons);
